import {faPlus} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Group} from '@mantine/core';
import {Link} from 'react-router-dom';
import {CosSelectionOptionsService} from '../api/generated/CosSelectionOptionsService';
import {BasicPage} from '../components/basic-page';
import {
  usePagedDataTable,
  PagedDataTableConfig,
  renderEditButton,
} from '../hooks/paged-data-table/use-paged-data-table';
import {ROUTES} from '../routes';

const RuntimeConfig = {
  renderActions: (
    <Button component={Link} to={ROUTES.ADMIN.COS_SELECTION_OPTIONS.CREATE.path}>
      <Group gap={'xs'}>
        <FontAwesomeIcon icon={faPlus} /> New COS Option
      </Group>
    </Button>
  ),
};

export const CosSelectionOptionListing = () => {
  const pagedDataTable = usePagedDataTable(
    CosSelectionOptionsService.getAll,
    TableConfig,
    {
      ...RuntimeConfig,
    }
  );

  return <BasicPage title="COS Selection Options">{pagedDataTable}</BasicPage>;
};

const TableConfig = PagedDataTableConfig(CosSelectionOptionsService.getAll, {
  columns: [
    {
      accessor: '',
      title: '',
      render: (item) =>
        renderEditButton({
          item: {...item, id: Number(item.id)},
          descriptor: 'COS Option',
          route: ROUTES.ADMIN.COS_SELECTION_OPTIONS.DETAIL.path,
        }),
      width: 50,
    },
    {
      accessor: 'label',
      sortable: true,
    },
    {
      accessor: 'days',
      title: 'Days',
      sortable: true,
    },
    {
      accessor: 'sortOrder',
      title: 'Sort Order',
      sortable: true,
    },
    {
      accessor: 'isActive',
      title: 'Status',
      render: (item) => (item.isActive ? 'Active' : 'Inactive'),
    },
  ],
  defaultSort: {
    column: 'sortOrder',
    direction: 'ASC',
  },
  searchFieldNames: ['label'],
});
